import { createSvgIcon } from '@mui/material'

export const OrderingClipboard = createSvgIcon(
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="scale(0.1589 0.1429)">
      <path
        d="M133.833 17.5007H99C95.5 7.83399 86.3333 0.833984 75.5 0.833984C64.6667 0.833984 55.5 7.83399 52 17.5007H17.1667C8 17.5007 0.5 25.0007 0.5 34.1673V150.834C0.5 160.001 8 167.501 17.1667 167.501H133.833C143 167.501 150.5 160.001 150.5 150.834V34.1673C150.5 25.0007 143 17.5007 133.833 17.5007ZM75.5 17.5007C80.0833 17.5007 83.8333 21.2507 83.8333 25.834C83.8333 30.4173 80.0833 34.1673 75.5 34.1673C70.9167 34.1673 67.1667 30.4173 67.1667 25.834C67.1667 21.2507 70.9167 17.5007 75.5 17.5007ZM92.1667 134.167H33.8333V117.501H92.1667V134.167ZM117.167 100.834H33.8333V84.1673H117.167V100.834ZM117.167 67.5007H33.8333V50.834H117.167V67.5007Z"
        fill="currentColor"
      />
    </g>
  </svg>,
  'OrderingClipboard'
)
